module.exports = __webpack_public_path__ + "public/img/组 5859.29fcdf80.png";